// extracted by mini-css-extract-plugin
export default {"genericCard":"Oo-z","inline":"Po-z","mastercard":"Qo-z","discover":"Ro-z","visa":"So-z","amex":"To-z","active":"Uo-z"};